import { render, staticRenderFns } from "./IpoInformation.vue?vue&type=template&id=e37d0d8a&scoped=true"
import script from "./IpoInformation.vue?vue&type=script&lang=js"
export * from "./IpoInformation.vue?vue&type=script&lang=js"
import style0 from "./IpoInformation.vue?vue&type=style&index=0&id=e37d0d8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37d0d8a",
  null
  
)

export default component.exports